<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import moment from 'moment';
    import { _ } from 'svelte-i18n';
    
    import FloatingButton from '../FloatingButton.svelte';
    import TimePicker from './TimePicker.svelte';
    import {dateFromHHmm} from "../../helpers/date.helper";
    import type {DashboardTimeRange} from "../../types/filters/dashboard-time-range.type";

    export let resetTime: boolean = false;
    
    const dispatch = createEventDispatcher();
    const defaultValue = '12:00';
    
    let startTime: string = defaultValue;
    let endTime: string = defaultValue;

    $: isTimeValid = endTimeIsAfterStartTime(startTime, endTime)
    $: valuesSet = (startTime.length > 0 || endTime.length > 0) && (startTime !== endTime);
    $: if(resetTime){
        startTime = defaultValue;
        endTime = defaultValue;
        
        resetTime = false;
    }

    function onStartTimeSelected(e: CustomEvent<string>): void {
        startTime = e.detail;
        emitCombined();
    }

    function onEndTimeSelected(e: CustomEvent<string>): void {
        endTime = e.detail;
        emitCombined();
    }

    function emitCombined() {
        let filter: DashboardTimeRange = endTimeIsAfterStartTime(startTime, endTime)
            ? { startTime: dateFromHHmm(startTime), endTime: dateFromHHmm(endTime) }
            : { startTime: undefined, endTime: undefined };
        
        dispatch('change', filter);
    }
    
    function endTimeIsAfterStartTime(startTime: string, endTime: string) {
        return moment(endTime, 'HH:mm').isAfter(moment(startTime, 'HH:mm'))
    }
    
    function getLabel(isTimeValid: boolean, valuesSet: boolean, startTime: string, endTime: string): string {
        if(!isTimeValid && !valuesSet){
            return $_('pages.dashboard.SELECT_TIME')
        }
        else if(!isTimeValid && valuesSet){
            return $_('pages.dashboard.STARTTIME_NOT_BEFORE_ENDTIME')
        }

        return `${startTime ? startTime : ''} ${startTime && endTime ? '-' : ''} ${endTime ? endTime : ''}`
    }

    $: label = getLabel(isTimeValid, valuesSet, startTime, endTime);
</script>

<FloatingButton label={label} active={isTimeValid && valuesSet} activeIcon="check" inactiveIcon="">
    <div class="time-picker-container">
        <TimePicker selectedTime={startTime} on:change={(e) => onStartTimeSelected(e)} />
        -
        <TimePicker selectedTime={endTime} on:change={(e) => onEndTimeSelected(e)} />
    </div>
</FloatingButton>

<style lang="scss">
    .time-picker-container {
        display: flex;
        align-items: center;
        gap: 8px;
        overflow-y: hidden;
    }
</style>
